import { Component, Input } from '@angular/core';

import { type PasswordEvaluation } from '../../../shared/services/password.service';

@Component({
  selector: 'app-password-requirements',
  templateUrl: './password-requirements-dialog.component.html',
  styleUrl: './password-requirements-dialog.component.scss',
  standalone: false
})
export class PasswordRequirementsDialogComponent {
  /** When true, shows the floating live checklist (focus popup). When false, dialog/info view. */
  @Input() live = false;

  /** Live evaluation used for ✅/❌ status. Ignored when live is false. */
  @Input() strength: PasswordEvaluation | null = null;

  isValid(key: keyof PasswordEvaluation): boolean {
    if (!this.live) {
      return true;
    }
    return !!this.strength?.[key];
  }

  icon(key: keyof PasswordEvaluation): string {
    if (!this.live) {
      return '';
    }
    return this.strength?.[key] ? '✅' : '❌';
  }
}
